import { styled } from '@mui/material/styles';

export const AppStatusBarRoot = styled('div', { label: 'AppStatusBarRoot' })(() => ({
  position: 'fixed',
  zIndex: 1300,
  top: 70,
  right: 10,
  width: 332,
}));
